import { css } from 'styled-components';
import { LoaderContainer } from 'modules/Loader/styled';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
import { PrimaryLabel, SecondaryLabel } from './styled';
const styles = {
    glass: {
        solid: {
            background: `color-mix(in srgb, ${theme.semantic.foreground.inverse}, transparent 95%)`,
            hover: {
                background: `color-mix(in srgb, ${theme.semantic.foreground.inverse}, transparent 80%)`,
            },
            active: {
                background: `color-mix(in srgb, ${theme.semantic.foreground.inverse}, transparent 80%)`,
            },
            focus: {
                shadowColor: theme.swatches.warm[200],
            },
            color: theme.semantic.foreground.inverse,
            secondaryColor: `color-mix(in srgb, ${theme.semantic.foreground.inverse}, transparent 25%)`,
            iconColor: theme.semantic.foreground.inverse,
        },
        outline: {
            background: `color-mix(in srgb, ${theme.semantic.foreground.inverse}, transparent 95%)`,
            borderColor: `color-mix(in srgb, ${theme.semantic.foreground.inverse}, transparent 95%)`,
            hover: {
                background: `color-mix(in srgb, ${theme.semantic.foreground.inverse}, transparent 80%)`,
            },
            active: {
                background: `color-mix(in srgb, ${theme.semantic.foreground.inverse}, transparent 80%)`,
            },
            focus: {
                shadowColor: theme.swatches.warm[200],
            },
            color: theme.semantic.foreground.inverse,
            secondaryColor: `color-mix(in srgb, ${theme.semantic.foreground.inverse}, transparent 25%)`,
            iconColor: theme.semantic.foreground.tertiary,
        },
    },
    primary: {
        solid: {
            background: theme.swatches.blue[50],
            hover: {
                background: theme.swatches.blue[100],
            },
            active: {
                background: theme.swatches.blue[200],
            },
            focus: {
                shadowColor: theme.swatches.blue[100],
            },
            color: theme.swatches.blue[500],
            iconColor: theme.swatches.blue[500],
        },
        outline: {
            background: theme.semantic.surface.primary,
            borderColor: theme.swatches.blue[500],
            hover: {
                background: theme.swatches.blue[50],
                borderColor: theme.swatches.blue[500],
            },
            active: {
                background: theme.swatches.blue[100],
                borderColor: theme.swatches.blue[500],
            },
            focus: {
                shadowColor: theme.swatches.blue[100],
            },
            color: theme.swatches.blue[500],
            iconColor: theme.swatches.blue[500],
        },
    },
    secondary: {
        solid: {
            background: theme.semantic.surface.sunken,
            hover: {
                background: theme.swatches.warm[100],
            },
            active: {
                background: theme.swatches.warm[200],
            },
            focus: {
                shadowColor: theme.swatches.blue[100],
            },
            color: theme.semantic.foreground.secondary,
            iconColor: theme.semantic.foreground.tertiary,
        },
        outline: {
            background: theme.semantic.surface.primary,
            borderColor: theme.semantic.border.default,
            hover: {
                background: theme.semantic.surface.sunken,
                borderColor: theme.semantic.border.default,
            },
            active: {
                background: theme.semantic.action.secondary.active,
                borderColor: theme.semantic.border.default,
            },
            focus: {
                shadowColor: theme.swatches.blue[100],
            },
            color: theme.semantic.foreground.secondary,
            iconColor: theme.semantic.foreground.tertiary,
        },
    },
    success: {
        solid: {
            background: theme.semantic.feedback.success.surface,
            hover: {
                background: theme.swatches.green[100],
            },
            active: {
                background: theme.swatches.green[200],
            },
            focus: {
                shadowColor: theme.swatches.green[200],
            },
            color: theme.semantic.text.success,
            iconColor: theme.swatches.green[500],
        },
        outline: {
            background: theme.semantic.surface.primary,
            borderColor: theme.swatches.green[500],
            hover: {
                background: theme.semantic.feedback.success.surface,
                borderColor: theme.swatches.green[500],
            },
            active: {
                background: theme.swatches.green[100],
                borderColor: theme.swatches.green[500],
            },
            focus: {
                shadowColor: theme.swatches.green[200],
            },
            color: theme.semantic.text.success,
            iconColor: theme.swatches.green[500],
        },
    },
    danger: {
        solid: {
            background: theme.semantic.feedback.danger.surface,
            hover: {
                background: theme.swatches.red[100],
            },
            active: {
                background: theme.swatches.red[200],
            },
            focus: {
                shadowColor: theme.swatches.red[200],
            },
            color: theme.semantic.text.danger,
            iconColor: theme.swatches.red[500],
        },
        outline: {
            background: theme.semantic.surface.primary,
            borderColor: theme.swatches.red[500],
            hover: {
                background: theme.semantic.feedback.danger.surface,
                borderColor: theme.swatches.red[500],
            },
            active: {
                background: theme.swatches.red[100],
                borderColor: theme.swatches.red[500],
            },
            focus: {
                shadowColor: theme.swatches.red[200],
            },
            color: theme.semantic.text.danger,
            iconColor: theme.swatches.red[500],
        },
    },
    warning: {
        solid: {
            background: theme.semantic.feedback.warning.surface,
            hover: {
                background: theme.swatches.yellow[100],
            },
            active: {
                background: theme.swatches.yellow[200],
            },
            focus: {
                shadowColor: theme.swatches.yellow[200],
            },
            color: theme.semantic.feedback.warning.text,
            iconColor: theme.swatches.yellow[900],
        },
        outline: {
            background: theme.semantic.surface.primary,
            borderColor: theme.swatches.yellow[500],
            hover: {
                background: theme.semantic.feedback.warning.surface,
                borderColor: theme.swatches.yellow[500],
            },
            active: {
                background: theme.swatches.yellow[100],
                borderColor: theme.swatches.yellow[500],
            },
            focus: {
                shadowColor: theme.swatches.yellow[200],
            },
            color: theme.semantic.feedback.warning.text,
            iconColor: theme.swatches.yellow[900],
        },
    },
    info: {
        solid: {
            background: theme.semantic.feedback.info.surface,
            hover: {
                background: theme.swatches.blue[100],
            },
            active: {
                background: theme.swatches.blue[200],
            },
            focus: {
                shadowColor: theme.swatches.blue[200],
            },
            color: theme.swatches.blue[500],
            iconColor: theme.swatches.blue[500],
        },
        outline: {
            background: theme.semantic.surface.primary,
            borderColor: theme.swatches.blue[500],
            hover: {
                background: theme.semantic.feedback.info.surface,
                borderColor: theme.swatches.blue[500],
            },
            active: {
                background: theme.swatches.blue[100],
                borderColor: theme.swatches.blue[500],
            },
            focus: {
                shadowColor: theme.swatches.blue[200],
            },
            color: theme.swatches.blue[500],
            iconColor: theme.swatches.blue[500],
        },
    },
};
function getOutlineCSS(appearance) {
    return css `
    background: ${appearance.background};
    border-color: ${appearance.borderColor};

    &:is(button) {
      &:hover {
        background-color: ${appearance.hover.background};
        border-color: ${appearance.hover.borderColor};
      }

      &:active {
        background-color: ${appearance.active.background};
        border-color: ${appearance.active.borderColor};
      }

      &:focus-visible {
        box-shadow: 0 0 0 ${pxToRem(4)} ${appearance.focus.shadowColor};
      }
    }

    ${PrimaryLabel} {
      color: ${appearance.color};
    }

    ${appearance.secondaryColor &&
        css `
        ${SecondaryLabel} {
          color: ${appearance.secondaryColor};
        }
      `};

    [data-icon='falcon'] {
      color: ${appearance.iconColor};
    }

    ${LoaderContainer} {
      color: ${appearance.iconColor};
    }
  `;
}
function getSolidCSS(appearance) {
    return css `
    background: ${appearance.background};
    border-color: transparent;

    &:is(button) {
      &:hover {
        background-color: ${appearance.hover.background};
      }

      &:active {
        background-color: ${appearance.active.background};
      }

      &:focus-visible {
        box-shadow: 0 0 0 ${pxToRem(4)} ${appearance.focus.shadowColor};
      }
    }

    ${PrimaryLabel} {
      color: ${appearance.color};
    }

    ${appearance.secondaryColor &&
        css `
        ${SecondaryLabel} {
          color: ${appearance.secondaryColor};
        }
      `};

    [data-icon='falcon'] {
      color: ${appearance.iconColor};
    }

    ${LoaderContainer} {
      color: ${appearance.iconColor};
    }
  `;
}
export const getChipAppearance = (appearance, variant) => {
    const defaultStyle = styles.primary.solid;
    const selectedAppearance = styles[appearance] || {};
    if (variant === 'outline') {
        return getOutlineCSS(selectedAppearance[variant]);
    }
    return getSolidCSS(selectedAppearance[variant] || defaultStyle);
};
